import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import useGlobalLabels from '@/shared/content/useGlobalLabels';
import { computed, ComputedRef } from 'vue';
import dictionaryService from '@/core/dictionary/dictionary.service';
import { GlobalLabels } from '@/shared/content/site-context.store';
import { LabelWithNamedArguments } from '@/b2c/shared/api/server-apis';


export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalLabelWithNamedArguments',
  props: {
    label: null,
    namespace: { default: undefined },
    tag: { default: 'div' }
  },
  setup(__props: any) {

const props = __props as { label: LabelWithNamedArguments, namespace: GlobalLabels, tag: string }



const labels = useGlobalLabels(props.namespace);

const formattedHtml: ComputedRef<string> = computed(() => dictionaryService.formatNamed(labels[props.label.label], props.label.namedParams));


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.tag), { innerHTML: _unref(formattedHtml) }, null, 8, ["innerHTML"]))
}
}

})